<template>
  <div>
    <label style="display: flex; position: relative; align-items: center">
      <vs-input class="project-selector-input w-full h-full member-selector"
                style="border-radius: 5px; background-color:#fff; "
                :value="selectProjectFieldName"
                @click="handleClickInput" :readonly="true" />
      <vs-icon icon-pack="feather" icon="icon-sidebar"
               style="padding-left:6px; padding-right:6px; position: absolute; top:auto; right:0; bottom:auto; font-size:24px; border-left: 1px solid #cdcdcd;"
      ></vs-icon>
    </label>
    <popup-search-project v-model="showPopup" :size="size" :selectId="(selectProjectId) ? selectProjectId : 0" @handleClickSelect="handleClickSelect"/>
  </div>
</template>

<script>
import PopupSearchMember from '@/popup/PopupSearchMember'
import PopupSearchProject from '@/popup/PopupSearchProject'

export default {
  name: 'ProjectSelector',
  components: {
    PopupSearchProject,
    PopupSearchMember},
  props: {
    value: [Number, String],
    readonly:Boolean,
    size: String,
    useName:Boolean,
  },
  watch: {
    value (data) {
      this.value = data
    }
  },

  data () {
    return {
      showPopup: false,
      selectProjectFieldName: '',
      selectProjectId:''
    }
  },

  methods: {

    handleClickInput () {
      if (!this.readonly) {
        this.showPopup = true
      }
    },

    handleClickSelect (_project) {
      this.selectProjectFieldName = _project.field_name
      this.selectProjectId = _project.id
      if (this.useName) {
        this.$emit('input', _project.field_name)
      } else {
        this.$emit('input', _project.id)
      }
      this.$emit('select', _project)
    }
  }
}
</script>

<style>
.member-selector input[readonly='readonly'] {
  background-color: #fff;
}
.project-selector-input .vs-inputx{
  padding-right: 45px !important;
}
</style>
